
import { defineComponent } from "vue";

export default defineComponent({
  name: "InfoField",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
